import './index.css'
import App from './App.js'
import { createRoot } from 'react-dom/client'
import products from './products.js'

const root = createRoot(document.querySelector('#ayea-player'))

// ?product=<code> overrides the hidden input, so a demo link can jump straight to a family
const productParam = new URLSearchParams(window.location.search).get('product')
const hasValidProductParam = productParam && products.some((p) => p.code === productParam)

const productId = hasValidProductParam
    ? productParam
    : document.getElementById('ayea-product-id').value
const groupProducts = document.getElementById('conf-group').value
const language = document.getElementById('conf-language').value

root.render(
    <App  productId={productId} groupProducts={groupProducts} language={language} />
);
